(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.pdf.overview
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.big-figure.pdf.view :as big-figures]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [potpuri.core :as potpuri]
   [frontend.ui.component.lp-portal.column.pdf.view :as column]
   [frontend.ui.style.theme.core :as theme]
   [frontend.ui.component.lp-portal.card.pdf.view :as card]))

(defn- recent-development-figures
  [recent-development]
  {:stack (concat [(->> recent-development
                        :figures
                        (table/dynamic-stack))]
                  (text-content/optional-footer recent-development))})

(defn- recent-development-page
  [report-data]
  (let [{:keys [recent-development recent-development-text highlights overview-figures]}
        (-> report-data
            :overview)]
    (page/page
     (page/third-column-background)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview" :toc-item true})
     (column/columns-2-to-1
      (card/card
       "Recent development"
       (text-content/rich-content (:rich-content recent-development-text)))
      (card/card
       nil
       (big-figures/table (-> report-data
                              :overview
                              :overview-figures
                              :figures)
                          1
                          {:row-gap 12})
       (text-content/optional-footer (-> report-data
                                         :overview
                                         :overview-figures)))))))

(defn- charts-page
  [report-data]
  (let [{:keys [total-investment net-asset-value historical-net-cash-flows-to-investors]}
        (-> report-data
            :overview)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
     {:stack
      [(column
        (card
         "Historical net cash flows to investors"
         {:svg       (chart-view/chart-svg "highcharts"
                                           (potpuri/deep-merge
                                            (:figures historical-net-cash-flows-to-investors)
                                            {:chart {:width  1600
                                                     :height 420}}))
          :width     800
          :alignment :center}
         (text-content/optional-footer historical-net-cash-flows-to-investors)))
       (columns
        (card
         "Current equity at cost"
         {:svg   (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge
                                        (:figures total-investment)
                                        {:chart {:width  800
                                                 :height 360}}))
          :width 400}
         (text-content/optional-footer total-investment))
        (card
         "Net asset value"
         {:svg   (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge
                                        (:figures net-asset-value)
                                        {:chart {:width  800
                                                 :height 360}}))
          :width 400}
         (text-content/optional-footer net-asset-value)))]})))

(defn- charts-page-2
  [report-data]
  (let [{:keys [sector-allocation-nav
                sector-allocation-gav
                country-allocation-nav
                country-allocation-gav]}
        (-> report-data
            :overview)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
     {:stack
      [(columns
      (when (:figures sector-allocation-nav)
        (card
         "Sector allocation, NAV"
         {:svg   (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge
                                        (:figures sector-allocation-nav)
                                        {:chart {:width  800
                                                 :height 360}}))
          :width 400}
         (text-content/optional-footer sector-allocation-nav)))
        (when (:figures sector-allocation-gav)
          (card
           "Sector allocation, GAV"
           {:svg   (chart-view/chart-svg "highcharts"
                                         (potpuri/deep-merge
                                          (:figures sector-allocation-gav)
                                          {:chart {:width  800
                                                   :height 360}}))
            :width 400}
           (text-content/optional-footer sector-allocation-gav))))
       (columns
        (when (:figures country-allocation-nav)
          (card
           "Country allocation, NAV"
           {:svg       (chart-view/chart-svg "highcharts"
                                             (potpuri/deep-merge
                                              (:figures country-allocation-nav)
                                              {:chart {:width  800
                                                       :height 360}}))
            :width     400
            :alignment :center}
           (text-content/optional-footer country-allocation-nav)))
        (when (:figures country-allocation-gav)
          (card
           "Country allocation, GAV"
           {:svg       (chart-view/chart-svg "highcharts"
                                             (potpuri/deep-merge
                                              (:figures country-allocation-gav)
                                              {:chart {:width  800
                                                       :height 360}}))
            :width     400
            :alignment :center}
           (text-content/optional-footer country-allocation-gav))))]})))

(defn overview-pages
  [report-data]
  (concat
   [(recent-development-page report-data)]
   (table/dynamic-table-pages {:fund-name (:fund-name report-data) :page-title "Overview"}
                              "Fund figures (IFRS)"
                              (->> report-data
                                   :overview
                                   :highlights)
                              {:odd-color     (theme/color [:pdf :table :odd-color])
                               :even-color    (theme/color [:pdf :table :even-color])
                               :heading-color (theme/color [:pdf :table
                                                            :heading-color])})
   [(charts-page report-data)
    (charts-page-2 report-data)]))
